import React, { FC } from 'react'
import t from 'src/translations/main'
import utils from 'src/components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from 'src/components/Core/Hooks/useForm/useForm'
import config from './config'

import Button from 'src/components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from 'src/components/Organisms/Form/Form.styles'
import { FormProps } from '../../../../Pages/Onboarding/types'

const IndividualWebsiteAccessForm: FC<FormProps> = props => {

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    emptyValidation,
    formData,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(props.fetchedData, config, submitForm)

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.IndividualAccount.WebsiteAccessForm.title')}
        </FormTitle>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualWebsiteAccessForm
